import React, { type FC } from 'react'

import { Flex, Text, TEXT_VARIANT_BOLD } from 'mailup-web-components'

import RenderWhen from 'Components/RenderWhen'

import { type UiEngagementSpec } from 'Pages/combinedFilterFormPage/filterConditionTypes'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar as faStarRegular } from 'mailup-fontawesome-kit/classic/regular'
import { faStar as faStarSolid } from 'mailup-fontawesome-kit/classic/solid'

const STAR_COLOR_ON = '#16a7cd'
const STAR_COLOR_OFF = '#cbcbcb'

interface EngagementIconProps {
  score: UiEngagementSpec['Value']
}

const size = {
  width: '15px',
  height: '15px',
}

const stars = Array.from({ length: 3 })

const EngagementIcon: FC<EngagementIconProps> = ({ score }) => {
  return (
    <Flex alignItems='center'>
      <RenderWhen condition={score === 'Abandoned'}>
        <Flex alignItems='center' justifyContent='start' width='45px'>
          <Text variant={TEXT_VARIANT_BOLD}>-</Text>
        </Flex>
      </RenderWhen>
      <RenderWhen condition={score === 'New'}>
        {stars.map((_, i) => (
          <FontAwesomeIcon
            key={i}
            icon={faStarRegular}
            color={STAR_COLOR_OFF}
            width={size.width}
            height={size.height}
          />
        ))}
      </RenderWhen>
      <RenderWhen condition={score === 'Inactive'}>
        {stars.map((_, i) => (
          <FontAwesomeIcon
            key={i}
            icon={faStarSolid}
            color={STAR_COLOR_OFF}
            width={size.width}
            height={size.height}
          />
        ))}
      </RenderWhen>
      <RenderWhen condition={score === 'LessActive'}>
        <FontAwesomeIcon
          icon={faStarSolid}
          color={STAR_COLOR_ON}
          width={size.width}
          height={size.height}
        />
        <FontAwesomeIcon
          icon={faStarSolid}
          color={STAR_COLOR_OFF}
          width={size.width}
          height={size.height}
        />
        <FontAwesomeIcon
          icon={faStarSolid}
          color={STAR_COLOR_OFF}
          width={size.width}
          height={size.height}
        />
      </RenderWhen>
      <RenderWhen condition={score === 'Active'}>
        <FontAwesomeIcon
          icon={faStarSolid}
          color={STAR_COLOR_ON}
          width={size.width}
          height={size.height}
        />
        <FontAwesomeIcon
          icon={faStarSolid}
          color={STAR_COLOR_ON}
          width={size.width}
          height={size.height}
        />
        <FontAwesomeIcon
          icon={faStarSolid}
          color={STAR_COLOR_OFF}
          width={size.width}
          height={size.height}
        />
      </RenderWhen>
      <RenderWhen condition={score === 'VeryActive'}>
        {stars.map((_, i) => (
          <FontAwesomeIcon
            key={i}
            icon={faStarSolid}
            color={STAR_COLOR_ON}
            width={size.width}
            height={size.height}
          />
        ))}
      </RenderWhen>{' '}
    </Flex>
  )
}

export default EngagementIcon
